/* @flow */
import React, { Component } from 'react'
import Modal from 'react-modal'
import jsonp from 'jsonp'
import Textarea from 'react-textarea-autosize'

import CommunityButtons from '../../Widgets/CommunityButtons/CommunityButtons'
import Button from '../../Widgets/Button/Button'

import './FormModal.css'

type Props = {
  open: boolean,
  handleClose: Function,
  participantType: string,
}

type State = {
  EMAIL: string,
  FULLNAME: string,
  COMPANY: string,
  COMMENTS: string,
  b_d643dcd42f277b3f147e60ac6_94e7e53569: string,
  isSubmitting: boolean,
  status: string,
  message: string,
  buttonError: boolean,
}

export default class FormModal extends Component<Props, State> {

  static defaultProps = {
    participantType: '',
  }

  state = {
    EMAIL: '',
    FULLNAME: '',
    COMPANY: '',
    COMMENTS: '',
    b_d643dcd42f277b3f147e60ac6_94e7e53569: '',
    isSubmitting: false,
    status: '',
    message: '',
    buttonError: false,
  }

  constructor(props: Object) {
		super(props);
		Modal.setAppElement('body');
	}

  handleSubmitError = (message) => {
    this.setState({
      status: 'error',
      message: message,
      isSubmitting: false,
      buttonError: true,
    });
    this.toggleButtonError();
  }

  handleSubmitSuccess = (message) => {
    this.setState({
      status: 'success',
      message: message,
      isSubmitting: false,
      buttonError: true,
    });
    this.toggleButtonError();
  }

  handleSubmit = (e: SyntheticEvent<HTMLInputElement>) => {
    e.preventDefault()

    if (this.state.isSubmitting) return null

    if (this.state.EMAIL.length < 1){
      this.setState({
        status: 'error',
        message: "Please enter your email address.",
        buttonError: true
      })
      this.toggleButtonError()
      return null;
    }

    const listId = (process.env.NODE_ENV === 'development') ? 'ae3659c31a' : '2dc7a654de'

    this.setState({
      isSubmitting: true
    })

    const url = "https://novoprotocol.us17.list-manage.com/subscribe/post-json?u=d643dcd42f277b3f147e60ac6&amp;id=" +
                listId +
                `&EMAIL=${encodeURIComponent(this.state.EMAIL)}` +
                `&FULLNAME=${encodeURIComponent(this.state.FULLNAME)}` +
                `&COMPANY=${encodeURIComponent(this.state.COMPANY)}` +
                `&COMMENTS=${encodeURIComponent(this.state.COMMENTS)}` +
                `&PTYPE=${encodeURIComponent(this.props.participantType)}`

    jsonp(url, {
        param: "c"
    }, (err, data) => {
      if (err){
        this.setState({
          status: 'error',
          message: err.message,
          isSubmitting: false
        })
      }else if(data.result === "error"){
        if (data.msg.includes("already subscribed")) {
          this.handleSubmitSuccess("You are already subscribed!");
        }else{
          this.handleSubmitError(data.msg);
        }
      }else{
        this.handleSubmitSuccess(data.msg);
      }
    })
  }

  toggleButtonError = () => {
    setTimeout(() => {
      this.setState({buttonError: false})
    }, 500);
  }

  onChange = (e: SyntheticEvent<HTMLInputElement>) => {
    const state = this.state
    state[e.currentTarget.name] = e.currentTarget.value;
    this.setState(state);
  }

  formTitle = () => {
    switch(this.props.participantType){
      case 'contributor':
        return 'Become a data provider'
      case 'consumer':
        return 'Become a data buyer'
      case 'verifier':
        return 'Become a data verifier'
      case 'partner':
        return 'Become a Novo partner'
      case 'whitepaper':
        return 'Request early access to the whitepaper'
      default:
        return 'Contact Us'
    }
  }

  commentsLabel = () => {
    switch(this.props.participantType){
      case 'contributor':
        return 'What type of data would you like to contribute?'
      case 'consumer':
        return 'What type of data do you need?'
      case 'verifier':
        return 'Why do you want to become a Data Verifier?'
      case 'partner':
        return 'How would you like to partner with Novo?'
      case 'whitepaper':
        return 'Why are you interested in learning more about Novo?'
      default:
        return 'Comments'
    }
  }

  render() {
    return(
      <Modal
          isOpen={this.props.open}
          onRequestClose={this.props.handleClose}
          contentLabel="Form Modal"
          overlayClassName="modal-overlay"
          className="form-modal"
        >
        <div className="modal-close">
          <a onClick={this.props.handleClose}><i className="icon icon-close" /></a>
        </div>
        { this.state.status === "success" ?
          <div className="modal-content-container--success">
            <svg className="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>
            <h3 className="modal-heading">Success!</h3>
            <p className="modal-subheading">We're glad you're excited about the future of Novo. We'll keep you updated on the progress of the platform!</p>
            <CommunityButtons/>
            <div className="button-container">
              <a className="button" onClick={this.props.handleClose}>CLOSE</a>
            </div>
          </div>
          :
          <div className="modal-content-container--form">
            <h3 className="modal-heading">{this.formTitle()}</h3>
            <form
              onSubmit={this.handleSubmit}
              method="post"
              name="contact-form"
              className="contact-form"
            >
              <div style={{position: 'absolute', left: '-5000px'}} aria-hidden="true">
                {/* real people should not fill this in and expect good things - do not remove this or risk form bot signups */}
                <input
                  onChange={this.onChange}
                  value={this.state.b_d643dcd42f277b3f147e60ac6_94e7e53569}
                  type="text"
                  name="b_d643dcd42f277b3f147e60ac6_94e7e53569"
                  tabIndex="-1"
                />
              </div>
              <input type="hidden" name="PTYPE" className="form-input" id="ptype" />
              <div className="form-group">
                <label htmlFor="name" className="form-label">NAME</label>
                <input type="text" value={this.state.FULLNAME} onChange={this.onChange} name="FULLNAME" className="form-input" id="name" maxLength="255" />
              </div>
              <div className="form-group">
                <label htmlFor="email" className="form-label">EMAIL ADDRESS*</label>
                <input type="email" value={this.state.EMAIL} onChange={this.onChange} name="EMAIL" className={this.state.status === 'error' ? "form-input form-input--error" : "form-input"} id="email" maxLength="255" />
                {this.state.status === 'error' &&
                  <div className="form-input--error-message">
                    {this.state.message}
                  </div>
                }
              </div>
              <div className="form-group">
                <label htmlFor="company" className="form-label">COMPANY NAME</label>
                <input type="text" value={this.state.COMPANY} onChange={this.onChange} name="COMPANY" className="form-input" id="name" maxLength="255" />
              </div>
              <div className="form-group">
                <label htmlFor="comments" className="form-label">{this.commentsLabel()}</label>
                <Textarea name="COMMENTS" value={this.state.COMMENTS} onChange={this.onChange} className="form-input" id="name" maxLength="255" />
                <div className="form-input--character-count">{255 - this.state.COMMENTS.length}</div>
              </div>
              <div className="form-button-group">
                <p className="form-terms">By clicking "submit", you agree to receive updates via email.</p>
                <Button text="SUBMIT" className="form-button" loading={this.state.isSubmitting} error={this.state.buttonError} />
              </div>
            </form>
          </div>
        }
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Widgets/FormModal/FormModal.js